import React from 'react';
import './App.css';
import Home from './Pages/Home';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Home />
      </header>
    </div>
  );
}

export default App;
